import useSisenseScmEventNoCourseDropdown from "./UseSisenseScmEventNoCourseDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseScmEventNoCourseDropdown = ({ label, name, value, error, message, onChange }) => {
  const { scmEventNoCourseOptions } = useSisenseScmEventNoCourseDropdown();

  return !scmEventNoCourseOptions.options
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={scmEventNoCourseOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={!scmEventNoCourseOptions.options}
      />
    );
};

export default SisenseScmEventNoCourseDropdown;